import { Settings } from "../environments.model";

export const settings: Settings = {
  appErrorPrefix: '[Angular Lemonaid Pims Error]',
  appTitle: 'Lemonaid Pims',
  version: '3.0.0',
  sentry_enabled: false,
};

export const settingsCmsUi: Settings = {
  appErrorPrefix: '[Angular Lemonaid CMS Error]',
  appTitle: 'Lemonaid CMS',
  version: '3.0.0',
  sentry_enabled: false,
};

export const settingsClinic: Settings = {
	appErrorPrefix: '[Angular Lemonaid Clinic Error]',
	appTitle: 'Lemonaid Clinic',
	version: '3.0.0',
  sentry_enabled: false,
  awin: {
    debug_mode: true,
    test_mode: 1,
  },
};
